<template>
  <div :dir="$functions.currentLangDirection()">
    <b-card
      class="devicesList d-md-block ddm-card"
      style="overflow-x: hidden;width: 100vw;
            height: calc( 100vh - 50px);
            padding: 0 !important;
            margin: 0 !important;
            top: 0 !important;
            left: 0 !important;
            position: absolute;"
    >
      <v-row style="background: #00abfd; margin: 0;">
        <v-col
          cols="8"
          md="8"
          style="padding-top: 2px;padding-bottom: 2px;"
        >
          <v-text-field
            v-model="listQuery"
            dark
            color="#fff"
            prepend-inner-icon="mdi-magnify"
            label="جستجوی نام، شناسه یا سیم‌کارت"
            class="searchDeviceInput"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
          md="4"
          style="padding-right: 0;padding-top: 0;padding-bottom: 0px;"
        >
          <b-button
            v-if="mobile != '09120000000'"
            variant="gradient-light"
            style="position: absolute;top: 14px;color: #fff;padding-right: 5px;padding-left: 0;"
            class="btn addDeviceBtn"
            @click="onAddDeviceClick()"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            /> ثبت دستگاه
          </b-button>
        </v-col>
      </v-row>
      <div class="dd-chips">
        <button
          v-for="c in statusChips"
          :key="c.value"
          class="dd-chip"
          :class="{ 'dd-chip-on': statusFilter === c.value }"
          @click="statusFilter = c.value"
        >
          <span
            v-if="c.color"
            class="dd-chipdot"
            :style="{ background: c.color }"
          />{{ c.label }}
        </button>
      </div>
      <div class="dd-list ddm-list">
        <div
          v-if="listLoading"
          class="dd-skel-wrap"
        >
          <div class="dd-loading-head">
            <v-progress-circular
              indeterminate
              size="18"
              width="2"
              color="#7367f0"
            />
            <span>در حال دریافت خودروها… لطفاً کمی شکیبا باشید</span>
          </div>
          <div
            v-for="n in skeletonRows"
            :key="'sk' + n"
            class="dd-skel"
          >
            <div class="dd-skel-ava" />
            <div class="dd-skel-lines">
              <div class="dd-skel-bar" style="width:55%" />
              <div class="dd-skel-bar" style="width:80%;height:18px" />
              <div class="dd-skel-bar" style="width:40%" />
            </div>
          </div>
        </div>
        <template v-else-if="pagedDevices.length">
          <device-row
            v-for="item in pagedDevices"
            :key="item.imei"
            :device="item"
            :menu-items="menuItems"
            @select="rowSelect"
            @action="onMenuAction"
            @renew="rowRenew"
          />
        </template>
        <div
          v-else
          class="dd-empty"
        >
          <v-icon
            size="42"
            color="#c4c8d4"
          >
            {{ (desserts && desserts.length) ? 'mdi-magnify-close' : 'mdi-car-off' }}
          </v-icon>
          <p class="dd-empty-txt">
            {{ (desserts && desserts.length) ? 'موردی با این جستجو/فیلتر پیدا نشد' : 'خودرویی برای نمایش نیست' }}
          </p>
        </div>
      </div>
      <div
        v-if="!listLoading && totalRecords > pageSizeOptions[0]"
        class="dd-pagerwrap"
      >
        <div
          v-if="pageCountDeviceTable > 1"
          class="dd-pager"
        >
          <button
            class="dd-pbtn dd-pbtn-wide"
            :disabled="pageDeviceTable <= 1"
            @click="goPage(pageDeviceTable - 1)"
          >
            قبلی
          </button>
          <template v-for="(p, i) in pagerItems">
            <span
              v-if="p === '...'"
              :key="'e' + i"
              class="dd-pellipsis"
            >…</span>
            <button
              v-else
              :key="'p' + p"
              class="dd-pbtn"
              :class="{ 'dd-pbtn-on': p === pageDeviceTable }"
              @click="goPage(p)"
            >
              {{ faDigits(p) }}
            </button>
          </template>
          <button
            class="dd-pbtn dd-pbtn-wide"
            :disabled="pageDeviceTable >= pageCountDeviceTable"
            @click="goPage(pageDeviceTable + 1)"
          >
            بعدی
          </button>
        </div>
        <div class="dd-pagesize">
          <span>نمایش در هر صفحه</span>
          <button
            v-for="size in pageSizeOptions"
            :key="'ps' + size"
            class="dd-psize"
            :class="{ 'dd-psize-on': size === itemsPerPage }"
            @click="setPageSize(size)"
          >
            {{ size ? faDigits(size) : 'همه' }}
          </button>
        </div>
      </div>
    </b-card>

    <b-modal
      ref="modal-change-sim"
      centered
      title="تغییر سیم‌کارت دستگاه"
      ok-title="ذخیره"
      cancel-title="بستن"
    >
      <b-form>
        <b-form-group label="شماره سیم‌کارت فعلی">
          <b-form-input
            v-model="device.sim"
            class="numeric-input"
            maxlength="11"
            disabled
          />
        </b-form-group>
        <b-form-group label="شماره سیم‌کارت جدید">
          <b-form-input
            v-model="simIdSelected"
            placeholder="09xxxxxxxxx"
            maxlength="11"
            class="numeric-input"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="hideModal('modal-change-sim')">بستن</b-button>
        <b-button size="sm" variant="primary" @click="modalChangeSim()">ذخیره</b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-change-name"
      centered
      title="تغییر نام خودرو"
      ok-title="ذخیره"
      cancel-title="بستن"
    >
      <b-form>
        <b-form-group label="نام فعلی">
          <b-form-input
            v-model="device.title"
            disabled
          />
        </b-form-group>
        <b-form-group label="نام جدید">
          <b-form-input
            v-model="newtitle"
            maxlength="100"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="hideModal('modal-change-name')">بستن</b-button>
        <b-button size="sm" variant="primary" @click="modalChangeTitle()">ذخیره</b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-change-category"
      centered
      title="تغییر نوع خودرو"
      ok-title="ذخیره"
      cancel-title="بستن"
    >
      <b-form>
        <b-form-group label="نوع وسیله نقلیه">
          <b-form-select
            v-model="device.category"
            :select-size="6"
          >
            <b-form-select-option
              v-for="(option, key) in options"
              :key="key"
              :value="key"
            >
              {{ option.text }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="hideModal('modal-change-category')">بستن</b-button>
        <b-button size="sm" variant="primary" @click="modalChangeCategory()">ذخیره</b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-send-sms"
      centered
      title="ارسال تنظیمات سرور"
      hide-footer
    >
      <p>برای تنظیم ردیاب خود، دستور زیر را به سیم‌کارت با شماره {{ device.sim }} پیامک کنید:</p>
      <code>{{ smsconfigtext }}</code>
      <div class="mt-1 d-flex" style="gap:8px;">
        <b-button size="sm" variant="primary" @click="modalSendSms()">ارسال پیامک</b-button>
        <b-button size="sm" variant="outline-secondary" @click="hideModal('modal-send-sms')">بستن</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody, BForm, BFormGroup, BFormInput, BFormSelect, BFormSelectOption,
} from 'bootstrap-vue'
import Vue from 'vue'
import Config from '../../../config'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import router from '@/router'
import UserService from '@/services/user.service'
import deviceService from '@/services/device.service'
import { getUserData } from '@/auth/utils'
import DeviceRow from '@/views/Home/components/DeviceRow.vue'
import { deviceDisplay } from '@/utils/deviceDisplay'

// تعدادِ خودرو در هر صفحه‌ی لیست: انتخابِ قبلیِ کاربر اگر هنوز جزوِ گزینه‌هاست، وگرنه پیش‌فرض
function readPageSize(key, fallback, options) {
  try {
    const saved = Number(localStorage.getItem(key))
    if (localStorage.getItem(key) !== null && options.includes(saved)) return saved
  } catch (e) { /* حالتِ خصوصی */ }
  return fallback
}

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BLink, BButton, BCard, BCardText, BCardBody, DeviceRow, BForm, BFormGroup, BFormInput, BFormSelect, BFormSelectOption,
  },
  data() {
    return {
      mobile: getUserData().mobile,
      desserts: Vue.prototype.$devices,
      pageDeviceTable: 1,
      // ۰ = «همه»؛ انتخابِ کاربر در localStorage می‌ماند
      itemsPerPage: readPageSize('4rah.mobileListPerPage', 3, [3, 10, 20, 50, 0]),
      pageSizeOptions: [3, 10, 20, 50, 0],
      search: '',
      listQuery: '',
      statusFilter: '',
      listLoading: true,
      listSyncTimer: null,
      device: {
        sim: '', imei: '', title: '', category: '', modelId: '',
      },
      simIdSelected: '',
      newtitle: '',
      message: '',
      smsconfigtext: 'SERVER,1,s1.payandservice.ir,4000,0#',
      options: Config.carTypes,
      statusChips: [
        { value: '', label: 'همه', color: '' },
        { value: 'move', label: 'در حرکت', color: '#28c76f' },
        { value: 'park', label: 'پارک', color: '#ff9f43' },
        { value: 'off', label: 'آفلاین', color: '#a8b1bd' },
        { value: 'exp', label: 'منقضی', color: '#ea5455' },
      ],
      menuItems: [
        { title: 'درخواست موقعیت لحظه‌ای', icon: 'mdi-crosshairs-gps', action: 'refresh' },
        { title: 'جزییات', icon: 'mdi-file-document-outline', action: 'detail' },
        { title: 'دستورات', icon: 'mdi-cog', action: 'command' },
        { title: 'سابقه حرکت', icon: 'mdi-map-marker-path', action: 'history' },
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  watch: {
    desserts(val) {
      if (val && val.length) this.listLoading = false
    },
    listQuery() {
      this.pageDeviceTable = 1
    },
    statusFilter() {
      this.pageDeviceTable = 1
    },
  },
  computed: {
    perPage() {
      return this.itemsPerPage || Math.max(1, this.totalRecords)
    },
    skeletonRows() {
      return Math.min(this.itemsPerPage || 6, 6)
    },
    totalRecords() {
      return this.filteredDevices.length
    },
    filteredDevices() {
      const toLatin = s => String(s || '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      const q = toLatin(this.listQuery).trim().toLowerCase()
      const status = this.statusFilter
      return (this.desserts || []).filter(item => {
        if (q) {
          const title = String(item.title || '').toLowerCase()
          const imei = toLatin(item.imei).toLowerCase()
          const sim = toLatin(item.sim).toLowerCase()
          if (!title.includes(q) && !imei.includes(q) && !sim.includes(q)) return false
        }
        if (status) {
          const kind = deviceDisplay(item).kind
          if (status === 'move' && !(kind === 'move' || kind === 'tow')) return false
          if (status === 'park' && !(kind === 'park' || kind === 'idle')) return false
          if (status === 'off' && kind !== 'off') return false
          if (status === 'exp' && kind !== 'exp') return false
        }
        return true
      })
    },
    pagedDevices() {
      const per = this.perPage
      const start = (this.pageDeviceTable - 1) * per
      return this.filteredDevices.slice(start, start + per)
    },
    pagerItems() {
      const total = this.pageCountDeviceTable
      const cur = this.pageDeviceTable
      if (total <= 5) {
        const all = []
        for (let i = 1; i <= total; i += 1) all.push(i)
        return all
      }
      const win = 3
      let start = Math.max(2, cur - 1)
      const end = Math.min(total - 1, start + win - 1)
      start = Math.max(2, end - win + 1)
      const items = [1]
      if (start > 2) items.push('...')
      for (let i = start; i <= end; i += 1) items.push(i)
      if (end < total - 1) items.push('...')
      items.push(total)
      return items
    },
    pageCountDeviceTable() {
      return Math.max(1, Math.ceil(this.totalRecords / this.perPage))
    },
    headers() {
      return [
        {
          text: 'Category',
          align: 'start',
          sortable: false,
          value: 'category',
          width: '45px',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
          width: '50%',
        },
        {
          text: 'Communication status',
          align: 'start',
          value: 'onlineStatus',
        },
        {
          text: 'Movement status',
          align: 'start',
          value: 'serverStatus',
        },
        {
          text: 'Satellite status',
          align: 'start',
          value: 'serverInfo',
        },
        {
          text: 'Options',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  created() {
    this.QXUpdateFirebaseData()
  },
  mounted() {
    // اسکلتون تا وقتی بماند که هم لیست آمده باشد و هم وضعیت/موقعیتِ خودروها لود شده باشد،
    // تا همهٔ خودروها لحظه‌ای «آفلاین» فلش نکنند و «خالی» هم نمایش داده نشود.
    this.syncFromGlobal()
    if (this.devicesReady()) {
      this.listLoading = false
    } else {
      // اگر منبعِ اصلی هنوز لیست/وضعیت ندارد، خودِ این صفحه لیست و موقعیت‌ها را لود می‌کند
      this.ensureDeviceList()
      this.listSyncTimer = setInterval(() => {
        this.syncFromGlobal()
        if (this.devicesReady()) {
          this.listLoading = false
          clearInterval(this.listSyncTimer)
          this.listSyncTimer = null
        }
      }, 800)
      // ایمنیِ نهایی: بعد از ۱۵ ثانیه در هر صورت اسکلتون برداشته شود
      setTimeout(() => {
        this.listLoading = false
        if (this.listSyncTimer) { clearInterval(this.listSyncTimer); this.listSyncTimer = null }
      }, 15000)
    }
    this.$root.$on('forceUpdate', payload => {
      if (payload.event === 'socket.devicePosition') {
        if ('imei' in payload.data) {
          this.syncFromGlobal()
          this.$forceUpdate()
        }
      }
    })
  },
  beforeDestroy() {
    if (this.listSyncTimer) { clearInterval(this.listSyncTimer); this.listSyncTimer = null }
  },
  methods: {
    setPageSize(size) {
      this.itemsPerPage = size
      this.pageDeviceTable = 1
      try { localStorage.setItem('4rah.mobileListPerPage', String(size)) } catch (e) { /* حالتِ خصوصی */ }
    },
    goPage(p) {
      if (p < 1 || p > this.pageCountDeviceTable) return
      this.pageDeviceTable = p
    },
    faDigits(n) {
      return String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
    rowSelect(device) {
      this.mapClick(device.imei)
    },
    rowRenew(device) {
      // روی موبایل، تمدید از صفحهٔ جزییاتِ دستگاه انجام می‌شود
      this.detailClick(device.imei)
    },
    rowRefresh2(device) {
      this.onSendCommand(device.imei, 'updatePosition')
    },
    onMenuAction(payload) {
      const imei = payload.device.imei
      const a = payload.action
      if (a === 'refresh') this.rowRefresh2(payload.device)
      else if (a === 'detail') this.detailClick(imei)
      else if (a === 'command') this.commandClick(imei)
      else if (a === 'history') this.historyClick(imei)
      else this.onEditItem(a, payload.device) // تغییر نام/نوع/سیم‌کارت/ارسال تنظیمات سرور
    },
    onEditItem(action, item) {
      this.device.imei = String(item.imei)
      this.device.sim = item.sim ? String(item.sim) : ''
      this.device.title = item.title ? String(item.title) : ''
      this.device.category = item.category
      this.simIdSelected = ''
      this.newtitle = ''
      if (action === 'modal-change-sim') this.$refs['modal-change-sim'].show()
      else if (action === 'modal-change-name') this.$refs['modal-change-name'].show()
      else if (action === 'modal-change-category') this.$refs['modal-change-category'].show()
      else if (action === 'modal-send-sms') this.$refs['modal-send-sms'].show()
    },
    hideModal(ref) {
      if (this.$refs[ref]) this.$refs[ref].hide()
    },
    toastErr(error) {
      this.message = (error.response && error.response.data) || error.message || error.toString()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'خطا', text: this.message, icon: 'XIcon', variant: 'danger',
        },
      })
    },
    modalChangeSim() {
      // eslint-disable-next-line radix
      deviceService.changeSim({ imei: parseInt(this.device.imei), sim: this.simIdSelected }).then(
        res => { if (res.status === 'success') { this.hideModal('modal-change-sim'); this.doFillDevices(); this.loadPositions() } },
        error => this.toastErr(error),
      )
    },
    modalChangeTitle() {
      // eslint-disable-next-line radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.newtitle, category: this.device.category }).then(
        res => { if (res.status === 'success') { this.hideModal('modal-change-name'); this.doFillDevices(); this.loadPositions() } },
        error => this.toastErr(error),
      )
    },
    modalChangeCategory() {
      // eslint-disable-next-line radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.device.title, category: this.device.category }).then(
        res => { if (res.status === 'success') { this.hideModal('modal-change-category'); this.doFillDevices(); this.loadPositions() } },
        error => this.toastErr(error),
      )
    },
    modalSendSms() {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.device.sim}&body=${this.smsconfigtext}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.device.sim}?body=${this.smsconfigtext}`
      } else {
        this.onSendCommand(this.device.imei, 'SERVER')
        this.hideModal('modal-send-sms')
      }
    },
    syncFromGlobal() {
      const g = Vue.prototype.$devices || []
      if (g !== this.desserts) this.desserts = g
    },
    devicesReady() {
      const g = this.desserts
      if (!g || !g.length) return false
      // حداقل یک خودرو وضعیت یا موقعیت داشته باشد (یعنی موقعیت‌ها لود شده‌اند)
      return g.some(x => (x.serverStatus && x.serverStatus.servertime) || (x.serverInfo && x.serverInfo.servertime))
    },
    async ensureDeviceList() {
      // اگر منبعِ اصلی خالی است، خودِ این تب لیست را از سرور می‌گیرد، بعد موقعیت‌ها را
      const g = Vue.prototype.$devices || []
      if (g.length) { await this.loadPositions(); return }
      try {
        const res = await deviceService.getList()
        if (res && res.status === 'success' && res.result && res.result.data && res.result.data.length) {
          Vue.prototype.$devices = res.result.data.map(d => {
            const fixed = Vue.prototype.$functions.fixDeviceInfo(d)
            fixed.onlineStatus = 'offlineSymbol'
            return fixed
          })
          this.syncFromGlobal()
          await this.loadPositions()
          return
        }
      } catch (e) {
        // نادیده
      }
      // واقعاً دستگاهی نبود
      this.listLoading = false
      if (this.listSyncTimer) { clearInterval(this.listSyncTimer); this.listSyncTimer = null }
    },
    async loadPositions() {
      const list = Vue.prototype.$devices || []
      if (!list.length) return
      try {
        const imeis = list.map(d => d.imei)
        const resp = await deviceService.getPositions({
          imeis, fromDate: 0, toDate: 0, limit: 1, sortItems: [{ name: 'servertime', desc: true }],
        })
        if (resp.status === 'success' && resp.result) {
          for (const imei in resp.result) {
            if (resp.result[imei].length > 0) {
              const idx = list.findIndex(d => d.imei === imei)
              if (idx !== -1) {
                const pos = resp.result[imei][0]
                const lastStatus = pos.lastStatus || null
                if (lastStatus) this.$set(list[idx], 'serverStatus', lastStatus)
                const serverInfo = { ...pos }
                delete serverInfo.lastStatus
                this.$set(list[idx], 'serverInfo', serverInfo)
              }
            }
          }
          if (Vue.prototype.$socket) Vue.prototype.$socket.emit('devicesOnlineTime', {})
        }
      } catch (e) {
        // نادیده
      }
      this.syncFromGlobal()
      this.listLoading = false
      if (this.listSyncTimer) { clearInterval(this.listSyncTimer); this.listSyncTimer = null }
    },
    onSendCommand(imei, commandName) {
      deviceService.sendCommand({
        imei,
        commandName,
      }).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: this.$t('An update request sent'),
                icon: 'XIcon',
                variant: 'success',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    detailClick(imei) {
      Vue.prototype.$selectDeviceDetail = imei
      this.$emit('on-change-page', 'home', 'detail', imei)
    },
    commandClick(imei) {
      Vue.prototype.$selectCommand = imei
      this.$emit('on-change-page', 'home', 'command', imei)
    },
    mapClick(imei) {
      // console.log(imei)
      this.$emit('on-change-page', 'home', 'map', imei)
    },
    historyClick(imei) {
      this.$emit('on-change-page', 'home', 'history', imei)
    },
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    isNoGpsSignal(imei) {
      return Vue.prototype.$functions.isNoGpsSignal(imei)
    },
    getStatusMovement(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.getStatusMovement(index)
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(index))
    },
    doFillDevices() {
      this.desserts = Vue.prototype.$devices
    },
    filterSearch(value) {
      this.desserts = Vue.prototype.$devices.filter(item => value.toLowerCase()
        .split(' ')
        .every(v => (item.imei || '').toLowerCase()
          .includes(v) || (item.title || '').toLowerCase()
          .includes(v)))
    },
    filterPerfectMatch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },

    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    sinceFromDevice(imei) {
      const d = this.getPopupInfo(imei)
      if (!d || !d.serverInfo) return this.$t('Unknown')
      const servertime = d.serverInfo.servertime || 0
      const statusServertime = d.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    buildLogoUrl(category) {
      try {
        return require(`@/assets/images/pins/cars/${this.options[category].src}.png`)
      } catch (e) {
        return require('@/assets/images/pins/cars/car.png')
      }
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
  },
}
</script>
<style>
/* لیستِ موبایل (نسخهٔ جدید، هماهنگ با دسکتاپ) */
.devicesList.ddm-card{height:calc(100vh - 115px) !important}
.devicesList .ddm-list{overflow:hidden}
.devicesList .dd-loading-head{display:flex;align-items:center;justify-content:center;gap:9px;padding:14px 12px 6px;font-size:12.5px;color:#7367f0}
.devicesList .dd-empty{padding:34px 20px;text-align:center;color:#9aa0ac}
.devicesList .dd-empty-txt{margin:10px 0 0;font-size:13px;color:#9aa0ac}
.devicesList .dd-chips{display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px;background:#fff}
.devicesList .dd-chip{display:inline-flex;align-items:center;gap:5px;font-size:12px;border:1px solid #ebe9f1;border-radius:20px;padding:5px 11px;color:#6e6b7b;background:#fff;font-family:inherit;cursor:pointer}
.devicesList .dd-chip-on{background:#7367f0;color:#fff;border-color:#7367f0}
.devicesList .dd-chipdot{width:9px;height:9px;border-radius:50%;display:inline-block}
.devicesList .dd-pager{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;padding:12px;border-top:1px solid #ebe9f1;background:#fff}
.devicesList .dd-pbtn{min-width:34px;height:34px;border-radius:8px;border:1px solid #ebe9f1;background:#fff;color:#6e6b7b;font-size:13px;font-family:inherit;padding:0 8px;cursor:pointer}
.devicesList .dd-pbtn-wide{padding:0 14px}
.devicesList .dd-pagerwrap{border-top:1px solid #ebe9f1;background:#fff}
.devicesList .dd-pagerwrap .dd-pager{border-top:0;padding-bottom:4px}
.devicesList .dd-pagesize{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:4px;padding:6px 12px 12px;font-size:12px;color:#8e8b9b}
.devicesList .dd-pagesize span{margin-inline-end:4px}
.devicesList .dd-psize{min-width:34px;height:28px;border-radius:14px;border:1px solid #ebe9f1;background:#fff;color:#6e6b7b;font-size:12px;font-family:inherit;padding:0 10px;cursor:pointer}
.devicesList .dd-psize-on{background:rgba(115,103,240,.12);color:#7367f0;border-color:#7367f0}
.devicesList .dd-pbtn-on{background:#7367f0;color:#fff;border-color:#7367f0}
.devicesList .dd-pbtn:disabled{opacity:.4;cursor:default}
.devicesList .dd-pellipsis{color:#9aa0ac;padding:0 2px;align-self:center}
.devicesList .dd-skel{display:flex;align-items:center;gap:11px;padding:14px;border-bottom:1px solid #ebe9f1}
.devicesList .dd-skel-ava{width:40px;height:40px;border-radius:50%;flex:none}
.devicesList .dd-skel-lines{flex:1;display:flex;flex-direction:column;gap:8px}
.devicesList .dd-skel-ava,.devicesList .dd-skel-bar{background:linear-gradient(90deg,#eef0f3 25%,#dfe3e9 50%,#eef0f3 75%);background-size:200% 100%;animation:ddshimmer 1.2s linear infinite}
.devicesList .dd-skel-bar{height:12px;border-radius:6px}
@keyframes ddshimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
</style>
<style>
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

[dir=ltr] .v-pagination__navigation {
  transform: rotateY(180deg);
}

[dir=rtl] .devicesList{
  top: 50px;
  width: 100%;
}
[dir=rtl] .devicesList .card-body{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 12px !important;
}
[dir=rtl] .devicesList {
  height: 100vh;
}
[dir=rtl] .devicesList {
  z-index: 998;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}
.devicesList .card, .devicesList .card-body {
  background: #f7f7f7;
}
[dir="rtl"] .devicesList {
  height: calc(100% - 50px);
  top: 0px;
  z-index: 99;
}
.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}
.devicesList .v-data-table>.v-data-table__wrapper>table{
  border-collapse: separate!important;    border-spacing: 0 0.8em;    background: #f7f7f7;
}
.devicesList .v-data-table__wrapper{
  padding-bottom: 35px;
}
</style>
